/**
 * Copyright (c) 2009 Sergiy Kovalchuk (serg472@gmail.com)
 *
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Following code is based on Element.mask() implementation from ExtJS framework (http://extjs.com/)
 *
 * cvillemure (2012-07-06) : Minor modifications to change the "label" parameter for a "spinner" parameter
 *                           Instead of displaying a messageBox, we show a javascript spinner in the middle
 *                           of the mask...
 * cvillemure (2015-11-19) : Remove the spinnerObject and replace it with a spinner size.  The spinner is
 *                          now a animated font from font-awesome (less CPU/GPU)!
 */
;(function($) {

	/*
	 * CUSTOM BOREALIS CODE
	 * For fullscreen mask
	 */
	// Get zindex from css (less)
	var elemstr = '<div class="maskDiv"></div>';
	var $elem = $(elemstr).hide().appendTo($('body'));
	var maskZIndex = $elem.css('zIndex');
	$elem.remove();

	/*
	 * END CUSTOM BOREALIS CODE
	 */

	/**
	 * Displays loading mask over selected element(s). Accepts both single and multiple selectors.
	 *
	 * @param delay Delay in milliseconds before element is masked (optional). If unmask() is called
	 *              before the delay times out, no mask is displayed. This can be used to prevent unnecessary
	 *              mask display for quick processes.
	 */
	$.fn.mask = function(delay) {
		$(this).each(function() {
			if (delay !== undefined && delay > 0) {
				var element = $(this);
				element.data("_mask_timeout", setTimeout(function() {
					$.maskElement(element);
				}, delay));
			} else {
				$.maskElement($(this));
			}
		});
	};

	/**
	 * Removes mask from the element(s). Accepts both single and multiple selectors.
	 */
	$.fn.unmask = function() {
		$(this).each(function() {
			$.unmaskElement($(this));
		});
	};

	$.maskElement = function(element) {
		if (element.hasClass("masked-spinner")) {
			return;
		}
		//if this element has delayed mask scheduled then remove it and display the new one
		if (element.data("_mask_timeout") !== undefined) {
			clearTimeout(element.data("_mask_timeout"));
			element.removeData("_mask_timeout");
		}

		if (element.css("position") === "static") {
			element.addClass("masked-relative");
		}

		element.addClass("masked-spinner");
		var maskDiv = $('<div class="loadmask"><div class="spinner spin-body"></div></div>');

		IMS.util.SpinnerUtil.initVue(maskDiv.find('.spinner'), {}, (err, vueObj) => {
			element.vueObj = vueObj;
		});

		// For fullscreen mask
		if (element.is("body")) {
			maskDiv.css("position", "fixed");
			maskDiv.css("width", "100%");
			maskDiv.css("height", "100%");
			maskDiv.css("z-index", maskZIndex);
		}
		element.append(maskDiv);
	};

	$.unmaskElement = function(element) {
		//if this element has delayed mask scheduled then remove it
		if (element.data("_mask_timeout") !== undefined) {
			clearTimeout(element.data("_mask_timeout"));
			element.removeData("_mask_timeout");
		}
		element.vueObj?.$destroy();
		element.removeClass("masked-spinner");
		element.removeClass("masked-relative");
		element.find("select").removeClass("masked-hidden");
		element.children(".loadmask-msg,.loadmask").remove();
	};

})(jQuery);
